import React from 'react';

import {observer} from 'mobx-react';
import {WebsiteModuleProps} from "../../models/website-module.props";
import {BettingPromotionModuleAsync} from "../../modules/betting-promotion.module/components/betting-promotion.module.async";

export const WebsiteModuleBettingPromotion = observer(({controller}: WebsiteModuleProps) => {
  return controller.state.appState.appBettingPromotionDisplayModel?.remoteConfigModel ? <BettingPromotionModuleAsync/> : null;
});
